import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getUsageSummary, type UsageSummary } from "../lib/api";
import Spinner from "../ui/Spinner";

function fmtMoney(n: number): string {
  if (n < 1) return `$${n.toFixed(3)}`;
  return `$${n.toFixed(2)}`;
}

export default function CostWidget() {
  const [summary, setSummary] = useState<UsageSummary | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const s = await getUsageSummary();
        if (!cancelled) setSummary(s);
      } catch (e) {
        if (!cancelled) setErr(e instanceof Error ? e.message : String(e));
      }
    };
    load();
    const t = setInterval(load, 30_000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, []);

  return (
    <Link
      to="/settings?tab=usage"
      className="block rounded-xl border border-ink-100 bg-white px-4 py-3 hover:border-brand-300 hover:shadow-sm hover:shadow-ink-900/5 transition min-w-[200px]"
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-ink-500 mb-0.5">
        This month
      </p>
      {err ? (
        <p className="text-sm text-red-600">Couldn't load</p>
      ) : !summary ? (
        <div className="flex items-center gap-2 text-ink-400 py-1">
          <Spinner size={12} />
          <span className="text-sm">Loading...</span>
        </div>
      ) : (
        <>
          <p className="font-display text-2xl font-bold text-ink-800 tabular-nums leading-none">
            {fmtMoney(summary.month_to_date_usd)}
          </p>
          <div className="flex gap-3 mt-2 text-[11px] text-ink-500">
            <span>
              AI {fmtMoney(summary.by_platform.anthropic ?? 0)}
            </span>
            <span>Img {fmtMoney(summary.by_platform.kie ?? 0)}</span>
            <span>
              Search {fmtMoney(summary.by_platform.tavily ?? 0)}
            </span>
          </div>
        </>
      )}
    </Link>
  );
}
